module.exports = __webpack_public_path__ + "static/media/actions.75f284dc.png";